/* Homepage-only presentation. No cart, product form or bundle logic. */
(() => {
  if (!document.body.classList.contains('bfh-page')) return;

  const setup = (root) => {
    root.querySelectorAll('[data-bfh-universes]').forEach((grid) => {
      if (grid.dataset.bfhReady) return;
      grid.dataset.bfhReady = 'true';
      grid.addEventListener('toggle', (event) => {
        if (!event.target.matches('.bfh-universe[open]')) return;
        grid.querySelectorAll('.bfh-universe[open]').forEach((other) => {
          if (other !== event.target) other.open = false;
        });
      }, true);
    });
  };

  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-bfh-close-menu]')) return;
    const menu = document.getElementById('sidebar-menu');
    if (menu && typeof menu.hide === 'function') menu.hide();
  });

  const mobile = window.matchMedia('(max-width: 699px)');
  const updateFooter = () => {
    document.querySelectorAll('.bfh-footer__group').forEach((group) => { group.open = !mobile.matches; });
  };
  updateFooter();
  mobile.addEventListener('change', updateFooter);
})();
